import { render, staticRenderFns } from "./EllipsisHIcon.vue?vue&type=template&id=095a6e39&"
import script from "./EllipsisHIcon.vue?vue&type=script&lang=js&"
export * from "./EllipsisHIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports